module.exports = "/assets/4655052dc8ede9cd2ce924ccfd481047.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CN.png
// module id = 1271
// module chunks = 0